/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';




am4core.addLicense("CH208466903");
am4core.useTheme(am4themes_animated);


const TypeRequestBarChart = (props) => {

    const { sBA, data,IsExport } = props


    useEffect(() => {
        if (data != null && data.length > 0) {
            (data).forEach((element, idx) => {
                GraphStackClusteredBar(element.lstYear, element.lstdata, element.sTitle, element.chartname,idx);
            });
        }

    }, [data,IsExport])


    const GraphStackClusteredBar = (lstYear, lstdata, sTitle, divId,idx) => {

        let chart = am4core.create(divId, am4charts.XYChart);
        chart.colors.step = 2;
        chart.zoomOutButton.disabled = true;

        let title = chart.titles.create();
        title.text = sTitle;
        title.fontSize = 16;
        title.marginBottom = 10;

        chart.legend = new am4charts.Legend()
        chart.legend.position = 'bottom'
        // chart.legend.paddingBottom = 20
        chart.legend.labels.template.maxWidth = 95

        let xAxis = chart.xAxes.push(new am4charts.CategoryAxis())
        xAxis.dataFields.category = 'sMonth'
        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.minGridDistance = 20;
        xAxis.renderer.cellStartLocation = 0.1;
        xAxis.renderer.cellEndLocation = 0.9;
        // xAxis.renderer.labels.template.rotation = -45;
        xAxis.renderer.labels.template.horizontalCenter = "middle";
        xAxis.renderer.labels.template.verticalCenter = "middle";

        let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
        yAxis.min = 0;

        function createSeries(value, name) {
            let series = chart.series.push(new am4charts.ColumnSeries())
            series.dataFields.valueY = value
            series.dataFields.categoryX = 'sMonth'
            series.name = name
            series.columns.template.tooltipText = name + ": [bold]{valueY}[/]";

            series.events.on("hidden", arrangeColumns);
            series.events.on("shown", arrangeColumns);

            let bullet = series.bullets.push(new am4charts.LabelBullet())
            bullet.interactionsEnabled = false
            bullet.dy = 30;
            bullet.label.text = '{valueY}'
            bullet.label.fill = am4core.color('#ffffff')

            return series;
        }
        //ปีจะเป็นปีที่เลือก
        chart.data = lstdata
        if (lstYear != null && lstYear.length > 0) {
            lstYear.forEach(element => {
                createSeries(element, element);
            });
        }

        function arrangeColumns() {

            let series = chart.series.getIndex(0);

            let w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
            if (series.dataItems.length > 1) {
                let x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
                let x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
                let delta = ((x1 - x0) / chart.series.length) * w;
                if (am4core.isNumber(delta)) {
                    let middle = chart.series.length / 2;

                    let newIndex = 0;
                    chart.series.each(function (series) {
                        if (!series.isHidden && !series.isHiding) {
                            series.dummyData = newIndex;
                            newIndex++;
                        }
                        else {
                            series.dummyData = chart.series.indexOf(series);
                        }
                    })
                    let visibleCount = newIndex;
                    let newMiddle = visibleCount / 2;

                    chart.series.each(function (series) {
                        let trueIndex = chart.series.indexOf(series);
                        let newIndex = series.dummyData;

                        let dx = (newIndex - trueIndex + middle - newMiddle) * delta

                        series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                        series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
                    })
                }
            }
        }

        if(IsExport == true)
        {
            setTimeout(() => {
                chart.exporting.getImage("png").then((data) => {
                    let obj = {
                        id: 5,
                        nOrder: idx+1,
                        sDesc: "",
                        sName : "",
                        idDiv : 5,
                        imgBase64: data
                    }
                    props.exportImg && props.exportImg(obj);
                });
            }, 2000);
        }

       
    }

    return (
        <>
            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 500 }}>กลุ่มตลาด: {sBA}</Typography>
                </Grid>
                {
                    data != null && data.length > 0 ?
                        data.map((element, index) => {
                            return (
                                <Fragment key={`voc_${index}`}>
                                    <Grid item xs={12} md={6}>
                                        <div id={`${element.chartname}`} style={{ width: "100%", height: "400px" }}></div>
                                    </Grid>
                                </Fragment>
                            )
                        })
                        : null
                }
            </Grid>
        </>
    )
}

export default TypeRequestBarChart